import { render } from "./SingleElection.vue?vue&type=template&id=d46ff5be&scoped=true"
import script from "./SingleElection.vue?vue&type=script&lang=js"
export * from "./SingleElection.vue?vue&type=script&lang=js"

import "./SingleElection.vue?vue&type=style&index=0&id=d46ff5be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d46ff5be"]])

export default __exports__